import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPayeeQuickInfo extends Layout {
    citystatePayee: CityState;
    panelPayeeInfo: Panel;
    sourceAllPayees: DataSource;
    textboxAddress: Textbox;
    textboxContactmobilePhone: Textbox;
    textboxContactname: Textbox;
    textboxContactphone: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
}
